const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(value, max));

export default clamp;
